import { Trans } from '@lingui/react'
import * as React from 'react'

import { NOTIFICATION_TYPES } from 'views/components/molecules/Notification'
import { NotificationCart } from 'views/components/organisms/Cart/NotificationCart'

const NotificationOrderDraft = (): React.ReactElement => (
  <NotificationCart type={NOTIFICATION_TYPES.ERROR}>
    <Trans id="cart.notification.missingOrderDraft" />
  </NotificationCart>
)

export { NotificationOrderDraft }
